class ProductMediaDescHandlerV2 {
  constructor(modalElement, productInfoElement) {
    this.modalElement = modalElement;
    this.productInfoElement = productInfoElement; // The <product-info> custom element
    
    this.descriptionOverlay = this.modalElement.querySelector('.product-media-description-overlay');
    this.descriptionTextElement = this.descriptionOverlay?.querySelector('.description-text-content');
    
    if (!this.modalElement || !this.descriptionOverlay || !this.descriptionTextElement) {
      // console.error('Modal or description elements not found for ProductMediaDescHandlerV2. Modal ID:', modalElement.id);
      return;
    }

    this.mediaAltTexts = this.loadMediaAltTexts();
    // console.log('[MediaDesc] Loaded media ALT texts:', JSON.parse(JSON.stringify(this.mediaAltTexts)));
    
    const modalObserver = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          if (this.modalElement.hasAttribute('open')) {
            setTimeout(() => this.handleModalOpen(), 50); 
          } else {
            this.handleModalClose();
          }
        }
      }
    });
    modalObserver.observe(this.modalElement, { attributes: true });

    // Listen for custom event when media changes via modal arrows
    this.modalElement.addEventListener('activemediaupdated', this.handleActiveMediaUpdateViaNavigation.bind(this));

    // Variant change listener is removed as ALT text is tied to media, not variant directly for this display logic.
    // If variant changes were to swap media *within the already open modal*, this would need to be re-evaluated.
  }

  loadMediaAltTexts() {
    const altTextsDataElement = document.getElementById('productMediaAltTextsJson');
    let altTexts = {};
    if (altTextsDataElement) {
      try {
        altTexts = JSON.parse(altTextsDataElement.textContent);
      } catch (e) {
        // console.error('Error parsing productMediaAltTextsJson:', e);
      }
    }
    return altTexts;
  }

  handleModalOpen() {
    const activeMediaIdInModal = this.modalElement.dataset.activeMediaId;
    // console.log('[MediaDesc] Modal opened. Active media ID in modal:', activeMediaIdInModal);

    if (activeMediaIdInModal) {
      this.displayAltTextForMedia(activeMediaIdInModal);
    } else {
      // console.log('[MediaDesc] No active media ID found on modal open.');
      this.clearDescription();
    }
  }

  handleModalClose() {
    // console.log('[MediaDesc] Modal closed, clearing description.');
    this.clearDescription();
  }

  displayAltTextForMedia(mediaId) {
    const altText = mediaId ? this.mediaAltTexts[mediaId] : null;
    // console.log(`[MediaDesc] Attempting to display ALT text for media ${mediaId}. Found ALT text:`, altText);
    
    if (typeof altText === 'string' && altText.trim() !== '') {
      // console.log('[MediaDesc] ALT text is valid, showing overlay with text:', altText);
      this.descriptionTextElement.innerHTML = altText; 
      this.descriptionOverlay.style.display = 'block';
    } else {
      // console.log('[MediaDesc] ALT text is empty or invalid, clearing description.');
      this.clearDescription();
    }
  }

  clearDescription() {
    // console.log('[MediaDesc] Clearing description and hiding overlay.');
    this.descriptionTextElement.innerHTML = '';
    this.descriptionOverlay.style.display = 'none';
  }

  handleActiveMediaUpdateViaNavigation(event) {
    const activeMediaId = event.detail.activeMediaId;
    // console.log('[MediaDesc] Active media updated by modal navigation. New active media ID:', activeMediaId);
    if (activeMediaId) {
      this.displayAltTextForMedia(activeMediaId);
    } else {
      this.clearDescription();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const productInfoElement = document.querySelector('product-info[data-section]'); 
  const modals = document.querySelectorAll('product-modal.product-media-modal');
  
  // console.log('[MediaDesc] DOMContentLoaded. Found product-info:', productInfoElement, `Found ${modals.length} modals.`);

  if (modals.length > 0) {
    modals.forEach(modal => {
      // console.log('[MediaDesc] Initializing ProductMediaDescHandlerV2 for modal:', modal.id);
      new ProductMediaDescHandlerV2(modal, productInfoElement);
    });
  } else {
    // console.log('[MediaDesc] No product media modals found to initialize.');
  }
}); 